import * as React from "react";
const SvgFiRrSunglasses = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sunglasses_svg__a)">
      <path
        fill="#062147"
        d="m23.896 13.749-1.402-9.48C22.135 1.835 20.008 0 17.548 0H16a1 1 0 1 0 0 2h1.548a3.02 3.02 0 0 1 2.968 2.562L21.764 13H18c-1.629 0-3.065.795-3.978 2.004-.008 0-.014-.004-.022-.004h-4c-.008 0-.014.004-.022.004C9.065 13.794 7.629 13 6 13H2.236l1.248-8.438A3.02 3.02 0 0 1 6.452 2H8a1 1 0 1 0 0-2H6.452c-2.46 0-4.587 1.835-4.946 4.269L.104 13.744A9 9 0 0 0 0 15.112V19c0 2.757 2.243 5 5 5h1c2.757 0 5-2.243 5-5v-1q-.001-.514-.101-1h2.202A5 5 0 0 0 13 18v1c0 2.757 2.243 5 5 5h1c2.757 0 5-2.243 5-5v-3.888c0-.455-.035-.915-.104-1.363M9 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-4h3.999c1.654 0 3 1.346 3 3zm13 0c0 1.654-1.346 3-3 3h-1c-1.654 0-3-1.346-3-3v-1c0-1.654 1.346-3 3-3h3.999z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sunglasses_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSunglasses;
